<template>
  <div id="admin-app">
    <AdminLayout v-if="$route.meta.adminLayout && authStore.isAuthenticated" :key="authStore.identityGeneration">
      <template #breadcrumb>{{ $route.meta.breadcrumb }}</template>
      <router-view v-slot="{ Component }">
        <keep-alive :max="8">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </AdminLayout>
    <router-view v-else-if="!$route.meta.adminLayout" />
  </div>
</template>

<script>
import AdminLayout from './layouts/AdminLayout.vue';
import { warmAdminData } from './api/adminData';
import { warmContentData } from './api/contentData';
import { useAdminAuthStore } from './store/adminAuth';

export default {
  name: 'App',
  components: { AdminLayout },
  setup: () => ({ authStore: useAdminAuthStore() }),
  data: () => ({
    hasWarmedAdminArea: false,
    warmupTimer: null,
    stopWarmupWatch: null,
    stopIdentityWatch: null,
  }),
  mounted() {
    this.stopIdentityWatch = this.$watch(() => this.authStore.identityGeneration, () => {
      window.clearTimeout(this.warmupTimer);
      this.hasWarmedAdminArea = false;
    });
    this.stopWarmupWatch = this.$watch(
      () => this.$route.meta.adminLayout,
      (isAdminRoute) => {
        if (!isAdminRoute || this.hasWarmedAdminArea) return;
        this.hasWarmedAdminArea = true;
        this.warmupTimer = window.setTimeout(() => {
          if (!this.authStore.isAuthenticated) return;
          const generation = this.authStore.identityGeneration;
          warmAdminData();
          // 先解析 runtime-config，避免预热请求快照到过期的内容 API 基址
          import('./api/content').then(({ ensureContentApiConfigured }) => {
            ensureContentApiConfigured().finally(() => {
              if (generation === this.authStore.identityGeneration && this.authStore.isAuthenticated) warmContentData();
            });
          });
          Promise.allSettled([
            import('./views/UserListView.vue'),
            import('./views/SubscriptionView.vue'),
            import('./views/ServiceListView.vue'),
            import('./views/ApplicationListView.vue'),
            import('./views/ApplicationDetailView.vue'),
            import('./views/LoginOriginListView.vue'),
            import('./views/LoginResultPagesView.vue'),
            import('./views/ContentCatalogView.vue'),
          ]);
        }, 0);
      },
      { immediate: true },
    );
  },
  beforeUnmount() {
    window.clearTimeout(this.warmupTimer);
    this.stopWarmupWatch?.();
    this.stopIdentityWatch?.();
  },
};
</script>

<style src="./assets/styles/admin-theme.css"></style>
